import { SPACES } from 'common/constants/sizes';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';

const OnPremTitle = () => {
  return (
    <>
      <Icon name={'onPrem'} size='smaller' color='shuttleGray' />
      <Text
        size='small'
        ml={SPACES.smaller}
        mr={SPACES.smaller}
        color='shuttleGray'
      >
        On premises agent
      </Text>
    </>
  );
};

export default OnPremTitle;
